import { mapServerSideChat, mapServerSideMessage } from '@/utils/api.mapper'
import { getChatInstanceWithToken } from '@/utils/axios'
import { Chat, Message, ServerSideChat, ServerSideMessage } from './types'

/* eslint-disable */
export interface ChatMessagesServerSideResponse {
  data: ServerSideMessage[];
  message_total: number;
  message_total_new: number;
}
/* eslint-enable */

export interface ChatMessagesResponse {
  messages: Message[]
  total: number
  new: number
}

export interface ChatListRequest {
  clientId: number
}

export const fetchChatList = async (req: ChatListRequest): Promise<Chat[]> => {
  const { data } = await getChatInstanceWithToken().get<{ data: ServerSideChat[] }>(
    `/chat/user/list?user_id=${req.clientId}`
  )

  return data.data.map(mapServerSideChat)
}

export interface ChatRequest {
  chatId: number
}

export const fetchChat = async (req: ChatRequest): Promise<Chat> => {
  const { data } = await getChatInstanceWithToken().get<{ data: ServerSideChat }>(
    `chat/${req.chatId}`
  )

  return mapServerSideChat(data.data)
}

export interface ChatMessagesRequest {
  chatId: number
  limit: number
  offset: number
}

export const fetchChatMessages = async (
  req: ChatMessagesRequest
): Promise<ChatMessagesResponse> => {
  const { data } = await getChatInstanceWithToken().get<ChatMessagesServerSideResponse>(
    `chat/${req.chatId}/messages?offset=${req.offset}&limit=${req.limit}`
  )

  return {
    total: data.message_total,
    new: data.message_total_new,
    messages: data.data.map(mapServerSideMessage).reverse(),
  }
}

export interface CreateChatRequest {
  clientId: number
}

export const createChat = async (req: CreateChatRequest): Promise<Chat> => {
  const { data } = await getChatInstanceWithToken().post<{ data: { id: number } }>('chat', {
    user_id: req.clientId,
  })

  const chat = await fetchChat({ chatId: data.data.id })
  return chat
}

export interface SendMessageRequest {
  clientId: number
  text: string
  chatId: number
}

export const sendMessage = async (req: SendMessageRequest): Promise<Message> => {
  const { data } = await getChatInstanceWithToken().post<{ data: ServerSideMessage }>('messages', {
    text: req.text,
    chat_id: req.chatId,
    app_id: 'mobile',
    user_id: req.clientId,
  })

  return mapServerSideMessage(data.data)
}

export interface SendFileRequest {
  chatId: number
  file: File
}

export const sendFile = async (req: SendFileRequest): Promise<Message> => {
  const request = new FormData()
  request.append('chat_id', String(req.chatId))
  request.append('file', req.file)
  request.append('text', 'test')

  const { data } = await getChatInstanceWithToken().post<{ data: ServerSideMessage }>(
    'files',
    request,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return mapServerSideMessage(data.data)
}

export interface FetchFileRequest {
  messageId: number
}

export const fetchFile = async (req: FetchFileRequest): Promise<string> => {
  const { data } = await getChatInstanceWithToken().get(`files/${req.messageId}`, {
    responseType: 'blob',
  })

  const fileAsBase64 = await new Promise<string>((res, rej) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)

    reader.onloadend = () => {
      if (typeof reader.result === 'string' || reader.result instanceof String) {
        res(reader.result.split(',')[1])
      }

      rej(reader.result)
    }

    reader.onerror = (e) => {
      rej(e)
    }
  })

  return fileAsBase64
}
